export const allPaddingDatalist = [
  { value: "0", style: "p-0" },
  { value: "px", style: "p-px" },
  { value: "0.5", style: "p-0.5" },
  { value: "1", style: "p-1" },
  { value: "1.5", style: "p-1.5" },
  { value: "2", style: "p-2" },
  { value: "2.5", style: "p-2.5" },
  { value: "3", style: "p-3" },
  { value: "3.5", style: "p-3.5" },
  { value: "4", style: "p-4" },
  { value: "5", style: "p-5" },
  { value: "6", style: "p-6" },
  { value: "7", style: "p-7" },
  { value: "8", style: "p-8" },
  { value: "9", style: "p-9" },
  { value: "10", style: "p-10" },
  { value: "11", style: "p-11" },
  { value: "12", style: "p-12" },
  { value: "14", style: "p-14" },
  { value: "16", style: "p-16" },
  { value: "20", style: "p-20" },
];
export const topPaddingDatalist = [
  { value: "0", style: "pt-0" },
  { value: "px", style: "pt-px" },
  { value: "0.5", style: "pt-0.5" },
  { value: "1", style: "pt-1" },
  { value: "1.5", style: "pt-1.5" },
  { value: "2", style: "pt-2" },
  { value: "2.5", style: "pt-2.5" },
  { value: "3", style: "pt-3" },
  { value: "3.5", style: "pt-3.5" },
  { value: "4", style: "pt-4" },
  { value: "5", style: "pt-5" },
  { value: "6", style: "pt-6" },
  { value: "7", style: "pt-7" },
  { value: "8", style: "pt-8" },
  { value: "9", style: "pt-9" },
  { value: "10", style: "pt-10" },
  { value: "11", style: "pt-11" },
  { value: "12", style: "pt-12" },
  { value: "14", style: "pt-14" },
  { value: "16", style: "pt-16" },
  { value: "20", style: "pt-20" },
];
export const bottomPaddingDatalist = [
  { value: "0", style: "pb-0" },
  { value: "px", style: "pb-px" },
  { value: "0.5", style: "pb-0.5" },
  { value: "1", style: "pb-1" },
  { value: "1.5", style: "pb-1.5" },
  { value: "2", style: "pb-2" },
  { value: "2.5", style: "pb-2.5" },
  { value: "3", style: "pb-3" },
  { value: "3.5", style: "pb-3.5" },
  { value: "4", style: "pb-4" },
  { value: "5", style: "pb-5" },
  { value: "6", style: "pb-6" },
  { value: "7", style: "pb-7" },
  { value: "8", style: "pb-8" },
  { value: "9", style: "pb-9" },
  { value: "10", style: "pb-10" },
  { value: "11", style: "pb-11" },
  { value: "12", style: "pb-12" },
  { value: "14", style: "pb-14" },
  { value: "16", style: "pb-16" },
  { value: "20", style: "pb-20" },
];
export const leftPaddingDatalist = [
  { value: "0", style: "pl-0" },
  { value: "px", style: "pl-px" },
  { value: "0.5", style: "pl-0.5" },
  { value: "1", style: "pl-1" },
  { value: "1.5", style: "pl-1.5" },
  { value: "2", style: "pl-2" },
  { value: "2.5", style: "pl-2.5" },
  { value: "3", style: "pl-3" },
  { value: "3.5", style: "pl-3.5" },
  { value: "4", style: "pl-4" },
  { value: "5", style: "pl-5" },
  { value: "6", style: "pl-6" },
  { value: "7", style: "pl-7" },
  { value: "8", style: "pl-8" },
  { value: "9", style: "pl-9" },
  { value: "10", style: "pl-10" },
  { value: "11", style: "pl-11" },
  { value: "12", style: "pl-12" },
  { value: "14", style: "pl-14" },
  { value: "16", style: "pl-16" },
  { value: "20", style: "pl-20" },
];
export const rightPaddingDatalist = [
  { value: "0", style: "pr-0" },
  { value: "px", style: "pr-px" },
  { value: "0.5", style: "pr-0.5" },
  { value: "1", style: "pr-1" },
  { value: "1.5", style: "pr-1.5" },
  { value: "2", style: "pr-2" },
  { value: "2.5", style: "pr-2.5" },
  { value: "3", style: "pr-3" },
  { value: "3.5", style: "pr-3.5" },
  { value: "4", style: "pr-4" },
  { value: "5", style: "pr-5" },
  { value: "6", style: "pr-6" },
  { value: "7", style: "pr-7" },
  { value: "8", style: "pr-8" },
  { value: "9", style: "pr-9" },
  { value: "10", style: "pr-10" },
  { value: "11", style: "pr-11" },
  { value: "12", style: "pr-12" },
  { value: "14", style: "pr-14" },
  { value: "16", style: "pr-16" },
  { value: "20", style: "pr-20" },
];
